import React from "react";

const Organization = () => {
  return (
    <div>
      <svg
        width="67"
        height="66"
        viewBox="0 0 67 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_319_581)">
          <path
            d="M32.351 49.3287C27.4652 48.4292 25.8449 44.6164 26.1658 41.4249C26.5358 37.7446 29.5471 35.0855 33.2927 35.088C36.8667 35.0904 39.9985 37.8852 40.3417 41.3786C40.7234 45.2645 38.3152 48.4645 34.1907 49.3378C34.8592 49.4693 35.3555 49.5565 35.8471 49.6653C41.4262 50.9006 45.3602 55.7099 45.4586 61.4173C45.4719 62.1925 45.4758 62.9684 45.4607 63.7434C45.4375 64.9354 44.6688 65.7335 43.494 65.7351C36.6584 65.7446 29.8226 65.7435 22.987 65.7356C21.9682 65.7344 21.1006 65.0508 21.0554 64.1122C20.9325 61.5573 20.9327 59.0097 22.079 56.62C24.0031 52.6084 27.1436 50.2303 31.525 49.501C31.7616 49.4615 31.9952 49.4034 32.351 49.3287Z"
            fill="currentColor"
          />
          <path
            d="M12.3122 14.3626C7.64316 13.3951 5.14745 10.5206 5.5086 6.61957C5.86601 2.759 8.80713 0.0242263 12.6238 0.00351743C16.1567 -0.0156908 19.2732 2.7497 19.7076 6.18198C20.1067 9.33679 18.3945 13.562 13.0378 14.3635C16.4183 14.5577 19.3171 15.7076 21.6097 18.1804C23.8806 20.6297 24.7702 23.6132 24.8599 26.8865C24.8777 27.5359 24.8886 28.1891 24.8392 28.8357C24.7563 29.9225 24.0134 30.6478 22.9305 30.6499C16.0474 30.6631 9.16438 30.6629 2.28132 30.6494C1.28124 30.6475 0.452681 29.9195 0.403291 28.9619C0.240003 25.7962 0.537543 22.706 2.28835 19.9466C4.4973 16.4652 7.7379 14.7243 11.7919 14.4045C11.9335 14.3932 12.0748 14.3817 12.3122 14.3626Z"
            fill="currentColor"
          />
          <path
            d="M52.8369 14.2664C50.6632 13.8396 48.9075 12.8083 47.7588 10.8867C46.8518 9.36923 46.5751 7.70576 46.8446 5.97566C47.381 2.53243 50.1993 0.0989854 53.6942 0.00354429C57.0538 -0.0881452 60.1171 2.28543 60.8384 5.56704C61.285 7.59891 60.9117 9.49453 59.738 11.2068C58.5835 12.8911 56.946 13.8605 54.9446 14.2934C56.9351 14.5403 58.7821 15.1287 60.4324 16.2299C64.1003 18.6773 65.9964 22.1202 66.098 26.5437C66.1124 27.1684 66.1013 27.7939 66.0998 28.4189C66.0961 29.9317 65.3754 30.6547 63.8463 30.6566C60.1556 30.6613 56.4648 30.6584 52.7742 30.6584C49.8067 30.6584 46.8391 30.6622 43.8716 30.6565C42.3461 30.6536 41.6537 29.9429 41.6214 28.4025C41.5729 26.0909 41.6479 23.7946 42.6517 21.6517C44.6828 17.3162 48.1128 14.9191 52.8369 14.2664Z"
            fill="currentColor"
          />
          <path
            d="M8.71099 34.559C9.97029 34.559 11.1847 34.559 12.4778 34.559C12.4579 37.9024 13.1337 41.0658 14.5923 44.0484C16.0422 47.013 18.111 49.4715 20.6699 51.4691C19.9856 52.5561 19.3371 53.5861 18.6842 54.6232C13.8398 52.9867 7.72647 40.7637 8.71099 34.559Z"
            fill="currentColor"
          />
          <path
            d="M54.0263 34.559C54.3171 34.5458 54.5599 34.526 54.8028 34.5251C55.7933 34.5215 56.7838 34.5236 57.7586 34.5236C58.844 40.5767 53.3842 51.6149 47.8334 54.6694C47.1747 53.6257 46.5148 52.5802 45.8257 51.4885C51.1645 47.1953 53.9488 41.5877 54.0263 34.559Z"
            fill="currentColor"
          />
          <path
            d="M44.6964 13.1987C43.7731 14.0552 42.8898 14.8963 41.974 15.7005C41.8373 15.8204 41.5117 15.8538 41.3357 15.7794C38.1437 14.4308 34.8128 14.0011 31.3838 14.2668C29.3118 14.4272 27.2967 14.8787 25.3871 15.7195C24.9367 15.9179 24.6609 15.8996 24.2929 15.5235C23.5106 14.7241 22.651 14.0007 21.8241 13.2471C25.5516 9.49665 39.2336 9.44622 44.6964 13.1987Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_319_581">
            <rect
              width="65.7407"
              height="65.7407"
              fill="white"
              transform="translate(0.364624 0.000976562)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Organization;
